
import React from 'react';

export default class Footer extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    return (
      <footer className="footer">
      <div className="container">
      <div className="navbar bg-dark row justify-content-center">
    <div className="navbar-inner">
        <div className="container">
        <small className="text-white">RHX ImapSync è un servizio di RHX Srl - <a href="https://www.rhx.it" className="text-white">www.rhx.it</a> - <a href="https://sync.rhx.it/policy" className="text-white">Policy</a></small>
        </div>
        </div>
        </div>
      </div>
    </footer>
    );
  }
}

/* <div className="navbar  fixed-bottom bg-dark row justify-content-center">
    <div className="navbar-inner">
        <div className="container">
        <small className="text-white">RHX ImapSync è un servizio di RHX Srl - <a href="https://www.rhx.it" className="text-white">www.rhx.it</a> - <a href="https://sync.rhx.it/policy" className="text-white">Policy</a></small>
        </div>
        </div>
        </div>
        */